export enum PlaceOrderErrorResponse {
  BANK_ID_PROMPT = 'user.must.have.valid.bankid.sign',
  EMPTY_CART = 'checkout.placeOrder.emptyCart',
  INVOICE_BLOCKED = 'user.blocked.from.invoice.payment',
  ORDER_LIMIT = 'b2b.user.orderlimit.not.high.enough.for.invoice.payment',
  WRONG_STORE = 'possible.wrong.store.on.order',
  NO_DELIVERY_SLOT = 'delivery.slot.is.null',
}
